import { environment } from '@environments/environment';
var ɵ0 = environment.eddressAppConfig.apiBaseUrl, ɵ1 = environment.eddressAppConfig.graphqlBaseUrl, ɵ2 = environment.eddressAppConfig.mainPortalUrl;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
